import { Component, Input, OnChanges } from '@angular/core';
import { WidgetMultiQuestionPreviewV0Dto } from './models/widget-multi-question-preview-v0.dto';
import { ND, WProperties } from '@pt/pt-models';
import { WidgetMultiQuestionResponseV0Dto } from './models/widget-multi-question-response-v0.dto';
import { WidgetDialogService } from '../../../services/widget-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'pt-widget-multi-question-v0-preview',
  template: `
    <ng-container *ngIf='loading; then LOADING; else PREVIEW'></ng-container>

    <ng-template #LOADING>
      Loading ...
    </ng-template>

    <ng-template #PREVIEW>

      <ng-container *ngIf='!previewData; then NODATA; else DATA'></ng-container>

      <ng-template #NODATA>
        <pt-widget-nodata [noDataLabel]="noDataLabel" *ngIf='showNoData'></pt-widget-nodata>
      </ng-template>

      <ng-template #DATA>
        <div class='pt-widget-multi-question-editor-v0' *ngIf='previewData'>


          <ul class='questions' *ngIf='previewData?.questions?.length > 0; else NO_QUESTION'>
            <ng-container *ngFor='let question of previewData.questions; let i = index'>
              <div class="widget-container">
                <div class='widget-row' [ngClass]="{'widget-row-striped': i % 2 === 0}">
                  <div style="width: 100px; min-width: 100px; padding: 8px;">{{ question.label }}</div>
                  <div class="w-col-2">
                    <div class="description">
                      <span [innerHTML]="question.question | formatNewlineToHtml"></span>
                      <pt-w-help [help]='question.help'></pt-w-help>
                    </div>
                    <div class="action">
                      <div class="badge-subtitle-ellipse"
                           container='body'
                           ngbTooltip="{{question.subTitle}}"
                           *ngIf="question.subTitle">
                        {{question.subTitle}}
                      </div>
                    </div>
                  </div> <!--end w-col-2-->

                  <div class="w-col-3">
                    <ng-container [ngSwitch]='question?.type '>
                      <div *ngSwitchCase="'RADIO_BUTTON'" class="wmq-select">
                        <pt-widget-multi-question-v0-radio-button
                          [noResponseLabel]="noResponseLabel"
                          [value]="question?.radioValue"
                          [answers]="question?.answers"
                          [readonly]="true">
                        </pt-widget-multi-question-v0-radio-button>
                      </div>

                      <div *ngSwitchCase="'CHECKBOX'" class="wmq-select"
                           [ngClass]='[question.answers.length > 5 ? "wmq-wrap" : ""]'>
                        <pt-widget-multi-question-v0-check-button
                          [noResponseLabel]="noResponseLabel"
                          [value]="question?.checkboxValue"
                          [answers]="question?.answers"
                          [readonly]="true">
                        </pt-widget-multi-question-v0-check-button>
                      </div>

                      <div *ngSwitchCase="'TEXT'" class='d-flex mt-1 mb-3 wmq-select'>
                        <pt-widget-multi-question-v0-text
                          [noResponseLabel]="noResponseLabel"
                          [value]="question?.textValue"
                          [readonly]="true">
                        </pt-widget-multi-question-v0-text>
                      </div>
                    </ng-container>

                    <div class="widget-btn-link wmq-note"
                         *ngIf="showNote"
                         (click)='clickNote(question)'
                    >
                      {{previewData.header.note ? previewData.header.note : ( "TITLE.NOTES" | translate )}}
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ul>

          <ng-template #NO_QUESTION>
            <div class='question-container'>
              <div class='missing-question'>Attenzione, non sono presenti domande</div>
            </div>
          </ng-template>

          <div *ngIf='previewData?.valutation && showEvalQuestion' class='valutation'>
            <div class='valutation-question'>{{ previewData?.valutation?.name }}</div>
            <ng-container *ngFor='let response of previewData?.valutation?.values; let iResponse = index'>
              <ng-container *ngIf='iResponse === previewData?.valutation?.checkedValueIndex'>
                <div class='valutation-response'>
                  <div [ngClass]='cssValutationResponse(response.value)'>
                    <span class="text-dark">{{ response.label }}</span>
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <div class='valutation-response'
                 *ngIf='previewData.valutation.checkedValueIndex === undefined'
            >{{ ND }}
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>
  `,
  styleUrls: [`./widget-multi-question-v0-preview.component.scss`]
})
export class WidgetMultiQuestionV0PreviewComponent implements OnChanges {
  @Input() noDataLabel?: string;
  @Input() previewData: WidgetMultiQuestionPreviewV0Dto;
  @Input() loading: boolean;
  @Input() showNoData: boolean;
  @Input() noResponseLabel: string;
  @Input() properties?: WProperties;

  public showNote = true;
  public showEvalQuestion = true;

  ND = ND;

  constructor(private widgetDialogService: WidgetDialogService, private translateService: TranslateService) {
  }

  ngOnChanges(): void {
    if (this.properties && this.properties.skipNote) {
      this.showNote = false;
    } else {
      this.showNote = true;
    }

    if (this.properties && this.properties.skipEvalQuestion) {
      this.showEvalQuestion = false;
    } else {
      this.showEvalQuestion = true;
    }
  }

  cssValutationResponse(iResponse: number) {
    switch (iResponse) {
      case 0:
        return 'very-high';
      case 1:
        return 'high';
      case 2:
        return 'medium-high';
      case 3:
        return 'medium';
      case 4:
        return 'medium-low';
      case 5:
        return 'low';
    }
  }

  clickNote(row: WidgetMultiQuestionResponseV0Dto) {
    const noteTitle: Observable<string> = this.previewData.header.note ? of(this.previewData.header.note) : this.translateService.stream('TITLE.NOTES');
    const dialog = this.widgetDialogService.runTextArea(
      noteTitle,
      row?.note,
      false);
    dialog.subscribe(() => {
    });
  }
}
